import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

interface Props {
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
  onReturnFocus?: () => void;
}

export function RemoveRevisionDialog({ pending, error, onClose, onConfirm, onReturnFocus }: Props) {
  const { t } = useTranslation('revisionHolds');
  return (
    <Dialog open onOpenChange={(open) => !open && !pending && onClose()}>
      <DialogContent
        className="overflow-hidden"
        showClose={!pending}
        onCloseAutoFocus={(event) => {
          if (onReturnFocus) {
            event.preventDefault();
            onReturnFocus();
          }
        }}
      >
        <DialogHeader>
          <DialogTitle className="pr-7">{t('removeTitle')}</DialogTitle>
          <DialogDescription>{t('removeDescription')}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <p className="text-ink-soft text-sm">{t('removeSelected')}</p>
          {error && (
            <p role="alert" className="text-sealwax mt-3 text-sm">
              {error}
            </p>
          )}
        </DialogBody>
        <DialogFooter className="flex-wrap">
          <Button className="min-h-11" variant="ghost" disabled={pending} onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            className="min-h-11"
            variant="destructive"
            loading={pending}
            disabled={pending}
            onClick={onConfirm}
          >
            {t('remove')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
